module.exports = __webpack_public_path__ + "media/images/app/homepage/hero_2_mobile-73b92100995695bc2a01fedbb659d057.webp";